import { API_URL, PENGAWAS_API_URL, SECRET_SESSION, API_URL_LOG, API_URL_PHOTO, API_URL_REDIS } from '../constants';
import { decrypt, encrypt_res, decrypt_res } from '../components/shares/GlobalFunction';
import axiosInstance from '../components/shares/axiosConfig';
import FirebaseService from '../services/firebase.service';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import NetError from '../components/NetworkError';
import { useNavigate } from 'react-router-dom';

// Configuration for access status check method
export const ACCESS_STATUS_CONFIG = {
  method: 'fcm', // 'interval' or 'fcm'
  intervalMs: 15000, // 15 seconds - default polling interval
  fcmPollingIntervalMs: 30000, // 2 minutes when FCM is active
  fallbackPollingIntervalMs: 30000, // 30 seconds when FCM fails or is not available
  intervalCaptureMs: 120000, // 120 seconds for capture image
};

const id_ujian_aktif = localStorage.getItem("id_ujian");
let id_test = localStorage.getItem("mulai_ujian");
if (id_test) {
  id_test = JSON.parse(decrypt(id_test));
  // console.log("id_test", id_test);
}
const id_projek_ujian = id_test;

// Function to clear all access status check timers
export const clearAccessStatusCheckTimers = (accessStatusCheckIntervalRef) => {
  accessStatusCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
  accessStatusCheckIntervalRef.current = [];
};

// Function to clear all notification check timers
export const clearNotificationCheckTimers = (notificationCheckIntervalRef) => {
  notificationCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
  notificationCheckIntervalRef.current = [];
};

// Function to show stop test modal and handle logout
export const showStopTestModal = (message, navigate) => {
  navigate("/peserta/logout");
  Swal.fire({
    title: 'Anda Dihentikan',
    text: message || 'Anda telah dihentikan dari ujian',
    icon: 'warning',
    confirmButtonText: 'OK'
  }).then(() => {
    if (navigate) {
      navigate("/peserta/logout");
    } else {
      window.location.href = "/peserta/logout";
    }
  });
};

const cameraCrossIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32"><path d="M149.1 64l15.6-32h182.5l15.6 32H448c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h85.1zM256 160c53 0 96 43 96 96 0 21.2-6.8 40.8-18.3 56.8L401 380.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L311.1 335.4C293.8 347.6 275.1 352 256 352c-53 0-96-43-96-96s43-96 96-96zm-48 96a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm205.7-154.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48.4 48.4-48.4-48.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48.4 48.4-48.4 48.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48.4-48.4 48.4 48.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48.4-48.4 48.4-48.4z" fill="currentColor"/></svg>';

export const showCameraOffModal = (message, navigate) => {
  console.log('camera off');
  navigate("/peserta/logout");
  Swal.fire({
    title: 'Kamera Tidak Berfungsi',
    text: message || 'Pastikan kamera menyala selama ujian berlangsung',
    icon: 'error',
    iconHtml: cameraCrossIcon,
    confirmButtonText: 'OK'
  }).then(() => {
    if (navigate) {
      navigate("/peserta/logout");
    } else {
      window.location.href = "/peserta/logout";
    }
  });
};

// Function to show supervisor message modal
export const showSupervisorMessageModal = (title, message) => {
  Swal.fire({
    title: title || 'Message from Supervisor',
    text: message,
    icon: 'info',
    confirmButtonText: 'OK'
  }).then(() => {
    // create function on confirm
    // setStarTimer("start");
    // timerRef.current.start();
  });
};
export const checkAndCapture = async (
  userData,
  headerRef,
  captureImageIntervalRef,
  kamera,
  timerRef,
  navigate
) => {
  if (kamera && kamera != 0) {
    const interval2 = setInterval(() => {
      try {
        let captureImage = headerRef.current.capture();
        if (captureImage){
          const payload_capture = {
            id_projek: userData.id_projek,
            id_siswa: userData.id_siswa,
            id_ujian: 0,
            nopes: userData.nopes,
            image: captureImage,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload_capture = encrypt_res(
            JSON.stringify(payload_capture),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
            data: encryptedPayload_capture
          });
        }else{
          if (kamera && kamera == 1){
            showCameraOffModal("Pastikan Kamera Anda Menyala", navigate);
            axiosInstance.post(API_URL_REDIS + "/redis/stopUjian", {
              id_siswa: userData.id_siswa,
              id_projek: userData.id_projek,
              id_ujian: id_ujian_aktif
            })
          }
          clearInterval(interval2);
          const payload_log = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            type: 'log',
            url: window.location.href,
            kategori: "Proses Tes",
            sub_kategori: "Pindah Subtes",
            remaining_time: timerRef.current.getCurrentSeconds,
            keterangan: `${userData.nopes} kamera gagal menangkap gambar peserta`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload_log = encrypt_res(
            JSON.stringify(payload_log),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload_log
          })
        } 
      } catch (error) {
        console.log(error);
      }
    }, ACCESS_STATUS_CONFIG.intervalCaptureMs); // 1 minute interval
    captureImageIntervalRef.current.push(interval2);
    return () => clearInterval(interval2);
  }
};
// Function to check access status via polling with configurable interval
export const checkAccessStatus = async (
  userData,
  id_ujian,
  accessStatusCheckIntervalRef,
  setAccessStatus,
  setCatatan,
  setStarTimer,
  setStopModalOpen,
  timerRef,
  navigate,
  pollingInterval = ACCESS_STATUS_CONFIG.intervalMs,
  setAlertTimeOutOpen
) => {
  // Clear any existing intervals to prevent duplicates
  let id_test = localStorage.getItem("mulai_ujian");
  if (id_test) {
    id_test = JSON.parse(decrypt(id_test));
    // console.log("id_test", id_test);
  }
  const id_projek_ujian = id_test;
  const accessToken = localStorage.getItem("token");
  clearAccessStatusCheckTimers(accessStatusCheckIntervalRef);
  const interval = setInterval(() => {
    // Prepare payload for status check
    const payload = {
        id_projek: userData.id_projek,
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        password: userData.kode_akses,
        id_ujian: id_ujian ?? 0,
        token: accessToken,
        id_projek_ujian: id_projek_ujian
    };
    
    // Encrypt payload following the app pattern
    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    
    // Make API call to check access status
    const now = Date.now();
    axiosInstance
      .post(API_URL + "/peserta/checkAccessStatus", {
        data: encryptedPayload,
      })
      .then((response) => {
        // alert(JSON.stringify(response.data.res));
        // Decrypt the response
        const end = Date.now();
        const ping = end - now;
        const decryptedResponse = response.data.res;
        
        // Set the access status
        setAccessStatus(decryptedResponse);
        
        // Check for status and handle accordingly
        if (decryptedResponse && decryptedResponse.length > 0) {
          
          const statusCheck = decryptedResponse[0];
          setAlertTimeOutOpen(statusCheck.statusTimeOut);
          //set statusTimeOut to localstorage
          localStorage.setItem('statusTimeOut_'+userData.id_siswa+'_'+id_projek_ujian, statusCheck.statusTimeOut);

          if(statusCheck.id_akses_ujian === 44 || statusCheck.id_akses_ujian === 57) {
            if (userData.pengawas == 1){
              setCatatan(statusCheck['text_catatan']);
              localStorage.setItem("pesan_henti", statusCheck['text_catatan']);
              timerRef.current.pause(); 
              setStarTimer("pause");
              showStopTestModal(statusCheck['text_catatan'], navigate);
              const payload_log = {
                id_siswa: userData.id_siswa,
                nopes: userData.nopes,
                nama_siswa: userData.nama_siswa,
                id_projek: userData.id_projek,
                type: 'log',
                url: window.location.href,
                kategori: "Proses Tes",
                sub_kategori: "Aktivitas Pengawas",
                remaining_time: 0,
                keterangan: `${userData.nopes} dihentikan oleh pengawas`,
                timeStamp: Math.floor(Date.now() / 1000)
              }
              const encryptedPayload_log = encrypt_res(
                JSON.stringify(payload_log),
                SECRET_SESSION
              );
              axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
                data: encryptedPayload_log
              })
            }
          } else if (statusCheck.is_logout){
            if (userData.pengawas == 1){
              setCatatan("Anda perlu request reset login");
              timerRef.current.pause(); 
              setStarTimer("pause");
              showStopTestModal("Terindikasi login di 2 perangkat. Anda perlu request reset login", navigate);
              const payload_log = {
                id_siswa: userData.id_siswa,
                nopes: userData.nopes,
                nama_siswa: userData.nama_siswa,
                id_projek: userData.id_projek,
                type: 'log',
                url: window.location.href,
                kategori: "Proses Tes",
                sub_kategori: "Aktivitas Pengawas",
                remaining_time: 0,
                keterangan: `${userData.nopes} terindikasi login di perangkat lain bersamaan`,
                timeStamp: Math.floor(Date.now() / 1000)
              }
              const encryptedPayload_log = encrypt_res(
                JSON.stringify(payload_log),
                SECRET_SESSION
              );
              axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
                data: encryptedPayload_log
              })
            }
          }

          // console.log("statusCheck", JSON.stringify(statusCheck));

          if (statusCheck.isTimeExpired === 1) {
            // alert("Sesi ujian telah berakhir!");
            timerRef.current.pause(); 
            setStarTimer("pause");

            let id_ujian_aktif = localStorage.getItem("id_ujian");

            axiosInstance.post(API_URL_REDIS + "/redis/stopUjian", {
              id_siswa: userData.id_siswa,
              id_projek: userData.id_projek,
              id_ujian: id_ujian_aktif
            })

            
            // alert("Sesi ujian telah berakhir! "+id_ujian_aktif+" "+id_ujian);
            showStopTestModal("Sesi ujian telah berakhir!", navigate);
          }

        }

        // axiosInstance
        //   .post("https://delivery-abm.bppp.kemdikbud.go.id/api-v2/redis/updatePing", {
        //     id_siswa: userData.id_siswa,
        //     ping: ping
        //   })
        //   .then((response) => {
        //     // console.log(ping);
        //   })
      })
      .catch((error) => {
        if (error.code == 'ERR_NETWORK'){
          // navigate("/error");
          localStorage.setItem('ERR_NET', Math.floor(Date.now() / 1000))
          Swal.fire({
            title: 'Koneksi Internet Terputus',
            text: "Pastikan kembali koneksi anda",
            icon: 'warning',
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: ACCESS_STATUS_CONFIG.fcmPollingIntervalMs
            // showConfirmButton: false
          }).then((result) => {
            if (result.isDismissed) {
              const now = Date.now();
              axiosInstance.post(API_URL + "/peserta/checkAccessStatus", {
                data: encryptedPayload,
              })
              .then((response) => {
                const end = Date.now();
                const ping = end - now;
                Swal.close();
              })
              .catch((error) => {
                console.error(error);
              });
            }
          });
        }
        // console.error("Error checking access status:", error);
      });
  }, pollingInterval);
  
  // Store interval reference for cleanup
  accessStatusCheckIntervalRef.current.push(interval);
  
  return () => {
    clearInterval(interval);
  };
};

// Function to check pengawas messages via polling with configurable interval
export const checkPesanPengawas = async (
  userData,
  notificationCheckIntervalRef,
  setModalMessageOpen,
  setPesanPengawas,
  setTimeStamp,
  pollingInterval = ACCESS_STATUS_CONFIG.intervalMs
) => {
  const interval = setInterval(() => {
    const payload = {
      id_siswa: userData.id_siswa,
      id_projek: userData.id_projek
    };
    
    // API call to check for new messages
    axiosInstance
      .post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory", payload)
      .then((response) => {
        const filtered_response = response.data.data.data.filter(item => item.is_read_by_room_owner === 0);
        if (filtered_response.length > 0){
          setPesanPengawas(filtered_response[filtered_response.length - 1].text);
          let temp_time = new Date(filtered_response[filtered_response.length - 1].created_at);
          temp_time.setTime(temp_time.getTime() + 7 * 60 * 60 * 1000);
          setTimeStamp(temp_time.toISOString());
          
          if (response.status === 200 && response.data.data.data.length > 0){
            setModalMessageOpen(true);
            const payload_log = {
              id_siswa: userData.id_siswa,
              nopes: userData.nopes,
              nama_siswa: userData.nama_siswa,
              id_projek: userData.id_projek,
              type: 'log',
              url: window.location.href,
              kategori: "Proses Tes",
              sub_kategori: "Aktivitas Pengawas",
              remaining_time: 0,
              keterangan: `${userData.nopes} mendapatkan pesan dari pengawas: ${filtered_response[filtered_response.length - 1].text}`,
              timeStamp: Math.floor(Date.now() / 1000)
            }
            const encryptedPayload_log = encrypt_res(
              JSON.stringify(payload_log),
              SECRET_SESSION
            );
            axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
              data: encryptedPayload_log
            })
          }
        }
      })
      .catch((error) => {
        console.error("ada yang salah", error);
      });
  }, pollingInterval);
  
  notificationCheckIntervalRef.current.push(interval);
  
  return () => {
    clearInterval(interval);
  };
};

// Function to register FCM token and set up dual notification system
export const registerFCMToken = async (
  userData,
  setFcmInitialized,
  setStarTimer,
  timerRef,
  setStopModalOpen,
  accessStatusCheckIntervalRef,
  notificationCheckIntervalRef,
  setAccessStatus,
  setCatatan,
  setModalMessageOpen,
  setPesanPengawas,
  setTimeStamp,
  navigate,
  id_ujian,
  setAlertTimeOutOpen,
  headerRef,
  captureImageIntervalRef,
  kamera
) => {
  try {
    // Initialize Firebase and request permission
    const fcmToken = await FirebaseService.requestNotificationPermission();
    
    if (!fcmToken) {
      console.error('Failed to get FCM token');
      // FCM failed, use fallback polling with 30-second interval
      checkAccessStatus(
        userData,
        id_ujian_aktif,
        accessStatusCheckIntervalRef,
        setAccessStatus,
        setCatatan,
        setStarTimer,
        setStopModalOpen,
        timerRef,
        navigate,
        ACCESS_STATUS_CONFIG.fallbackPollingIntervalMs,
        setAlertTimeOutOpen
      );
      checkPesanPengawas(
        userData,
        notificationCheckIntervalRef,
        setModalMessageOpen,
        setPesanPengawas,
        setTimeStamp,
        ACCESS_STATUS_CONFIG.fallbackPollingIntervalMs
      );
      checkAndCapture(userData, headerRef, captureImageIntervalRef, kamera, timerRef, navigate);
      return;
    }

    // Register token with backend
    const payload = {
      id_siswa: userData.id_siswa,
      fcm_token: fcmToken,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
    };

    const encryptedPayload = encrypt_res(JSON.stringify(payload), SECRET_SESSION);
    
    await axiosInstance.post(API_URL + "/fcm/register-token", {
      data: encryptedPayload
    });

    // Set up message listener for FCM
    FirebaseService.setupMessageListener((notification) => {
      if (notification.type === 'STOP_TEST' && userData.pengawas == 1) {
        setStarTimer("pause");
        timerRef.current.pause();
        showStopTestModal(notification.message, navigate);
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Proses Tes",
          sub_kategori: "Aktivitas Pengawas",
          remaining_time: 0,
          keterangan: `${userData.nopes} dihentikan oleh pengawas`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
      } else if (notification.type === 'RESET_LOGIN' && userData.pengawas == 1) {
        setStarTimer("pause");
        timerRef.current.pause();
        showStopTestModal("Anda sedang request reset login", navigate);
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Proses Tes",
          sub_kategori: "Aktivitas Pengawas",
          remaining_time: 0,
          keterangan: `${userData.nopes} perlu reset login`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
      } else if (notification.type === 'SUPERVISOR_MESSAGE') {
        showSupervisorMessageModal(notification.title, notification.message);
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Proses Tes",
          sub_kategori: "Aktivitas Pengawas",
          remaining_time: 0,
          keterangan: `${userData.nopes} mendapatkan pesan dari pengawas: ${notification.message}`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
      }
    });

    setFcmInitialized(true);
    
    // FCM is active, set up polling with 2-minute interval as backup
    checkAccessStatus(
      userData,
      id_ujian_aktif,
      accessStatusCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      ACCESS_STATUS_CONFIG.fcmPollingIntervalMs,
      setAlertTimeOutOpen
    );
    checkPesanPengawas(
      userData,
      notificationCheckIntervalRef,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      ACCESS_STATUS_CONFIG.fcmPollingIntervalMs
    );
    checkAndCapture(userData, headerRef, captureImageIntervalRef, kamera, timerRef, navigate);
    
  } catch (error) {
    console.error('Error setting up FCM:', error);
    // FCM failed, use fallback polling with 30-second interval
    checkAccessStatus(
      userData,
      id_ujian_aktif,
      accessStatusCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      ACCESS_STATUS_CONFIG.fallbackPollingIntervalMs,
      setAlertTimeOutOpen
    );
    checkPesanPengawas(
      userData,
      notificationCheckIntervalRef,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      ACCESS_STATUS_CONFIG.fallbackPollingIntervalMs
    );
    checkAndCapture(userData, headerRef, captureImageIntervalRef, kamera, timerRef, navigate);
  }
};

// Function to initialize notification system based on configuration
export const initializeNotificationSystem = (
  userData,
  id_ujian,
  accessStatusCheckIntervalRef,
  notificationCheckIntervalRef,
  setAccessStatus,
  setCatatan,
  setStarTimer,
  setStopModalOpen,
  timerRef,
  navigate,
  setModalMessageOpen,
  setPesanPengawas,
  setTimeStamp,
  setFcmInitialized,
  setAlertTimeOutOpen,
  headerRef,
  captureImageIntervalRef,
  kamera,
) => {
  if (ACCESS_STATUS_CONFIG.method === 'fcm') {
    // Try FCM first, with fallback to polling
    registerFCMToken(
      userData,
      setFcmInitialized,
      setStarTimer,
      timerRef,
      setStopModalOpen,
      accessStatusCheckIntervalRef,
      notificationCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      navigate,
      id_ujian,
      setAlertTimeOutOpen,
      headerRef,
      captureImageIntervalRef,
      kamera
    );
  } else{
    // Use polling only with default interval
    checkAccessStatus(
      userData,
      id_ujian_aktif,
      accessStatusCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      ACCESS_STATUS_CONFIG.intervalMs,
      setAlertTimeOutOpen
    );
    checkPesanPengawas(
      userData,
      notificationCheckIntervalRef,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      ACCESS_STATUS_CONFIG.intervalMs
    );
    checkAndCapture(userData, headerRef, captureImageIntervalRef, kamera, timerRef, navigate);
  }
};
